import React, { useState, useEffect } from 'react';

import Button from 'b2b-ui-components-lib/lib/components/button';

import CancelOrderPopup from 'dedicated/components/cancelOrderPopup/cancelOrderPopup';
import EmailPopup from 'dedicated/components/emailPopup/emailPopup';

import { numberWithCommas, showServiceError } from 'common/utils/app.utils';

import './index.scss';
import { GENERIC_ERROR_MESSAGE, isAppointmentJourney, isBulkUpgrade, isNLD_OR_LL, ORDER_TYPE } from 'common/constants/app.constants';
import { isOrderConfirmationUrl } from 'dedicated/services/summary.service';
import CustomModal from 'home/view/upgrade-order/components/common/CustomModal';

const Footer = (props) => {
  let {
    isFormValid,
    submitOrder,
    updateOrder,
    order,
    isSaveBtnDisabled,
    totalSites = 0,
    isOrderConfirmation = false,
    setNotification = () => {},
    fetchOrder = () => {},
    showEmailPopup = false,
    orderConfirmationPopup = false,
    setShowEmailPopup = () => {},
    setOrderConfirmationPopup = () => {},
    isUpgrade = false,
    customerDetail,
    setCustomerDetail,
    showLoader,
    onSubmitClick
  } = props;

  const totalPrice = order && order.lead && order.lead.planDetail && order.lead.planDetail.totalPrice;

  const { orderStatus, ocLinkSentAtList } = order || {};
  const email = ocLinkSentAtList?.join(', ').toString();

  const [showCancelPopup, setShowCancelPopup] = useState(false);
  const [viewMore, setViewMore] = useState(false);

  const onViewMoreLessClick = () => {
    setViewMore(!viewMore);
  };

  const onCancel = () => {
    setShowCancelPopup(true);
  };

  const isOrderConfirmationPending = () => {
    return orderStatus === ORDER_TYPE.ORDER_CONFIRMATION_PENDING;
  };

  const onSubmit = () => {
    if (isAppointmentJourney()) {
      onSubmitClick?.();
    } else if (isOrderConfirmationPending()) {
      fetchOrder(isUpgrade ? setOrderConfirmationPopup : setShowEmailPopup);
      if (isUpgrade) {
        setOrderConfirmationPopup(true);
      } else {
        setShowEmailPopup(true);
      }
    } else {
      updateOrder(null, isBulkUpgrade() ? true : false, isBulkUpgrade() ? true : false).then(
        (resp) => {
          if (isUpgrade) {
            setOrderConfirmationPopup(true);
          } else {
            setShowEmailPopup(true);
          }
        },
        (error) => {
          console.error(error);
          const errorMsg = (error && error.response && error.response.data && error.response.data.errorMsg) || GENERIC_ERROR_MESSAGE;
          showServiceError({ show: true, data: errorMsg, redirect: false });
        }
      );
    }
  };

  const setOTPVerification = (verified) => {
    if (verified) {
      submitOrder();
    }
  };

  useEffect(() => {
    document.getElementById('root').className = 'pricing-strip';
    return () => {
      document.getElementById('root').classList.remove('pricing-strip');
    };
  }, []);

  return (
    <div className={`order-footer selected-plans active ${showEmailPopup || showCancelPopup || orderConfirmationPopup ? 'open' : ''}`}>
      <div className={`inside-plan ${viewMore ? 'show_full_view' : ''}`}>
        <div className="plan-info">
          <div className="plan_details_veiw">
            <div className="left_col">
              <h4>Total Amount</h4>
              <div class="value mt-10">&#8377; {totalPrice ? numberWithCommas(totalPrice) : 'N/A'}</div>
            </div>
            <div className="right_col">
              <div className="view_type" onClick={onViewMoreLessClick}>
                {viewMore ? 'View Less' : 'View More'} <span className={`animatedarrow ${viewMore ? 'arrow_up' : ''} `}></span>
              </div>
            </div>
          </div>
          <div className="condition_info">Excluding Taxes.</div>
        </div>
        <div className="plan-details">
          <div className="item_list">
            <div className="items tital_for_mobile">
              <div className="label">{isNLD_OR_LL() ? 'Total Links in Order' : 'Total Sites in Order'}</div>
              <div className="value">
                <strong>{totalSites ? totalSites : '-'} </strong>
              </div>
            </div>
            <div className="items total_for_desktop border-bottom">
              <div className="label">{isNLD_OR_LL() ? 'Total Links in Order' : 'Total Sites in Order'}</div>
              <div className="value">
                <strong>{totalSites ? totalSites : '-'} </strong>
              </div>
            </div>
          </div>

          <div className="action">
            <Button variant="outlinebtn" onClick={onCancel}>
              Cancel
            </Button>
            {isOrderConfirmation ? (
              <Button className="activebtn" onClick={onSubmit}>
                {isAppointmentJourney() ? 'Proceed' : 'Confirm Order'}
              </Button>
            ) : (
              <Button className="activebtn" disabled={!isFormValid || isSaveBtnDisabled} onClick={onSubmit}>
                {isAppointmentJourney() ? 'Proceed' : 'Confirm Order'}
              </Button>
            )}
          </div>
        </div>
      </div>

      {showCancelPopup && <CancelOrderPopup isUpgrade={isUpgrade} isMultiSite isSummaryPage setshowPopup={setShowCancelPopup} metaData={order}></CancelOrderPopup>}

      {showEmailPopup && (
        <EmailPopup
          isMultiSite
          setshowPopup={setShowEmailPopup}
          email={email}
          setOTPVerification={setOTPVerification}
          orderStatus={orderStatus}
          isOrderConfirmation={isOrderConfirmation && isOrderConfirmationUrl()}
          fetchOrder={fetchOrder}
          setNotification={setNotification}
          customer={customerDetail}
          setCustomerDetail={setCustomerDetail}
        ></EmailPopup>
      )}
      {orderConfirmationPopup && (
        <CustomModal
          submitOrderPopup
          customPopupTitle="Confirm Order"
          customPopupMsg="Are you sure you want to place the order?"
          submitCustomPopup={() => {
            submitOrder();
          }}
          closeCustomPopup={() => setOrderConfirmationPopup(false)}
          loading={showLoader}
          // leadData={leadData}
        />
      )}
    </div>
  );
};

export default Footer;
